/**
 * Show the fixed “back to top” link after scrolling. The control is a same-page
 * anchor to `#header`; the browser handles navigation and focus.
 */
(function () {
  const el = document.getElementById('back-to-top');
  if (!el) return;

  let threshold = window.innerHeight;

  function checkVisible() {
    window.requestAnimationFrame(() => {
      if (window.scrollY > threshold) {
        el.classList.add('back-to-top--active');
      } else {
        el.classList.remove('back-to-top--active');
      }
    });
  }

  function onResize() {
    threshold = window.innerHeight;
    checkVisible();
  }

  window.addEventListener('scroll', checkVisible, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
  checkVisible();
})();
